import { PropertyType } from '..';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => formData.append(key, data[key]));
	return formData;
};
